import { compressImage } from "../services/image";
export default class Image {
  static get toolbox() {
    return {
      title: "Image",
      icon:
        '<i class="fad fa-image-polaroid pluginIcon"></i>',
    };
  }

  constructor({ data, api }) {
    if (data && data.name && data.dataUrl)
      this.data = {
        name: data.name,
        dataUrl: data.dataUrl,
        alt: data.alt || '',
        attribution: data.attribution || ''
      };
    this.api = api;

    this.wrapper = undefined;
  }

  render() {
    this.wrapper = document.createElement('div');
    this.wrapper.classList.add('proEditorWrapper');

    if (this.data && this.data.dataUrl && this.data.name) {
      this._renderImage();
      return this.wrapper;
    }

    const fileInput = document.createElement('input');
    fileInput.setAttribute("type", "file");
    fileInput.classList.add('cdx-input');
    this.wrapper.appendChild(fileInput);

    fileInput.addEventListener('change', (e) => this._handleImageUpload(e.target.files[0]));
    fileInput.addEventListener('drop', (e) => this._handleImageUpload(e.dataTransfer.files[0]));

    return this.wrapper;
  }

  _handleImageUpload(file) {

    // check image dimension
    let _URL = window.URL || window.webkitURL;
    let img = new window.Image();

    var objectUrl = _URL.createObjectURL(file);

    let self = this;
    img.onload = function () {
      let allow = true;
      if (this.width != 1000) {
        allow = false;
        if (confirm("Image is not 1000px wide. Are you sure ?")) allow = true;
      }

      if (allow) {
        compressImage(file, null, (name, dataUrl) => {
          self.data = { ...self.data, name, dataUrl };
          self._renderImage();
        });
      }
      _URL.revokeObjectURL(objectUrl);
    };
    img.src = objectUrl;
  }

  _renderImage() {
    this.wrapper.innerHTML = '';

    let image = document.createElement("img");
    image.src = this.data.dataUrl;
    this.wrapper.appendChild(image);

    const altInput = document.createElement('input');
    altInput.placeholder = "Brief image description";
    altInput.classList.add('cdx-input', '--italic', 'mt-1');
    altInput.value = this.data.alt || "";
    this.wrapper.appendChild(altInput);

    altInput.addEventListener('input', (e) => {
      this.data = { ...this.data, alt: e.target.value };
    });

    const creditInput = document.createElement('input');
    creditInput.placeholder = "Give credits to image owner";
    creditInput.classList.add('cdx-input', '--italic', 'mt-1');
    creditInput.value = this.data.attribution || "";
    this.wrapper.appendChild(creditInput);

    creditInput.addEventListener('input', (e) => {
      this.data = { ...this.data, attribution: e.target.value };
    });
  }

  save() {
    return this.data;
  }
}